import { Base } from '@studiometa/js-toolkit';
import { nextFrame } from '@studiometa/js-toolkit/utils';

/**
 * Loadmore class
 */
export default class Loadmore extends Base {
  static config = {
    name: 'Loadmore',
    refs: ['btn', 'postContainer'],
    emits: ['posts-loaded'],
  };

  /**
   * Mounted
   * @returns {void}
   */
  mounted() {
    this.nextLink = this.$refs.btn.href;
    this.lastRequest = false;
  }

  /**
   * Click on see more
   * @param  {object} e
   * @returns {void}
   */
  onBtnClick(e) {
    e.preventDefault();
    this.$refs.btn.disabled = true;
    this.fetchPosts();
  }

  /**
   * Fetch articles.
   * @returns {void}
   */
  fetchPosts() {
    const request = new XMLHttpRequest();
    request.open('GET', this.nextLink, true);
    request.responseType = 'document';
    request.send(null);
    request.addEventListener('readystatechange', async () => {
      if (request.readyState === 4) {
        const doc = request.response;
        const posts = doc.querySelectorAll('.tease');
        const btnPagination = doc.querySelector('.btn--loadmore');

        if (btnPagination) {
          this.nextLink = btnPagination.href;
        } else {
          this.$refs.btn.style.display = 'none';
          this.lastRequest = true;
        }
        posts.forEach((post, index) => {
          post.classList.add(
            'tease--hide',
            'opacity-0',
            'translate-y-10',
            'duration-500',
            'transition',
          );
          post.style.transitionDelay = `${index / 10}s`;
          this.$refs.postContainer.append(post);
        });

        await nextFrame();
        await nextFrame();

        const newPost = document.querySelectorAll('.tease--hide');
        newPost.forEach((element) => {
          element.classList.remove('tease--hide', 'opacity-0', 'translate-y-10');
        });

        this.$emit('posts-loaded');

        this.$refs.btn.disabled = false;
        if (this.lastRequest) {
          this.$terminate();
        }
      }
    });
  }
}
